import { PusherService } from './services/pusher.service';
import { AuthenticationService } from './services/authentication.service';
import { Component } from '@angular/core';
import { GeolocationService } from './services/geolocation.service';
import { MessagingService } from './services/messaging.service';
import { TranslateService } from '@ngx-translate/core';
import { Status } from "src/app/models/enumStatus.model"

import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'veriftoo';
  authenticated: boolean = false;
  public userStatus = Status;
  public isConnected: boolean = false;

  constructor(
    public auth: AuthenticationService,
    private pusher: PusherService,
    private geolocation: GeolocationService,
    private messaging: MessagingService,
    private translate: TranslateService,
	private router: Router,

  ) {
    this.initTranslate();
	
    this.auth.currentAuthUser.subscribe((user) => {
      this.isConnected = user && user.exists();
      this.authenticated = user && user.exists() && user.status == this.userStatus.Validated ? true : false;
      if (this.authenticated) {
        geolocation.getCurrentPosition();
      } else if (this.isConnected && !this.router.url.startsWith('/auth/')) {
        this.router.navigate(['/auth/validateaccount']);
      }
    });
  }

  initTranslate() {
    // Translations are pre-loaded by APP_INITIALIZER — just register available langs
    this.translate.addLangs(['fr', 'en']);
  }
  
  //logout event if not authenticated
  logout() {
	console.log("logout");
	this.auth.logout();
	console.log(this.auth.getCurrentAuthUser());
	//this.router.navigate(['orders']);
  }
}
